import { render, staticRenderFns } from "./ItemImageCarousel.vue?vue&type=template&id=ebb652f2"
import script from "./ItemImageCarousel.vue?vue&type=script&lang=js"
export * from "./ItemImageCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebb652f2')) {
      api.createRecord('ebb652f2', component.options)
    } else {
      api.reload('ebb652f2', component.options)
    }
    module.hot.accept("./ItemImageCarousel.vue?vue&type=template&id=ebb652f2", function () {
      api.rerender('ebb652f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/ItemImageCarousel.vue"
export default component.exports